module.exports = __webpack_public_path__ + "static/files-6f75c012fd48d2439c0fe56cce1a9f83.png";